import React, { FC } from 'react';
import { Subscription } from '../../../common/model/dto/subscription';
import OvListTableField from '../atoms/OvListTableField';
import DateUtils from '../../../common/utils/services/date-utils';
import styled from 'styled-components';
import OvButton from '../atoms/OvButton';
import Variables from '../../../design-system/variables';
import Colours from '../../../design-system/colours';
import { Constants } from '../../../common/constants';
import { Link } from '@mui/material';
import OvListTableButtonField from '../atoms/OvListTableButtonField';
import { useTranslation } from 'react-i18next';

interface OvSubscriptionListRowProps {
  subscription: Subscription;
}

const OvSubscriptionListRow: FC<OvSubscriptionListRowProps> = ({
  subscription,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <OvListTableField>
        <StatusLabel
          style={{
            backgroundColor: subscription?.is_active
              ? Colours.OV_GREEN
              : Colours.OV_RED,
          }}
        >
          <StyledText>
            {subscription?.is_active ? 'active' : 'canceled'}
          </StyledText>
        </StatusLabel>
      </OvListTableField>

      <OvListTableField>
        {subscription?.stripe_subscription.created
          ? DateUtils.formatDate(
              new Date(subscription.stripe_subscription.created * 1000),
              'MMMM DD, YYYY, HH:mm:ss'
            )
          : '-'}
      </OvListTableField>

      <OvListTableField>
        {subscription?.canceled_at
          ? DateUtils.formatDate(
              subscription?.canceled_at as unknown as Date,
              'MMMM DD, YYYY, HH:mm:ss'
            )
          : '-'}
      </OvListTableField>

      <OvListTableField>
        {DateUtils.formatDate(
          subscription?.created_at as unknown as Date,
          'MMMM DD, YYYY, HH:mm:ss'
        )}
      </OvListTableField>

      <OvListTableField>
        <Link
          href={`https://dashboard.stripe.com/${
            !Constants.IS_PRODUCTION ? 'test/' : ''
          }invoices/${subscription?.stripe_subscription.latest_invoice}`}
          target="_blank"
        >
          {t('subscriptions.latestInvoice')}
        </Link>
      </OvListTableField>

      <OvListTableButtonField style={{ textAlign: 'center' }}>
        <StyledOvButton>
          <Link
            href={`https://dashboard.stripe.com/${
              !Constants.IS_PRODUCTION ? 'test/' : ''
            }subscriptions/${subscription?.stripe_subscription_id}`}
            target="_blank"
          >
            {t('subscriptions.manageSubscription')}
          </Link>
        </StyledOvButton>
      </OvListTableButtonField>
    </>
  );
};

export default OvSubscriptionListRow;

const StyledOvButton = styled(OvButton)`
  && {
    border-radius: ${Variables.borderRadius.CLINIC_DASHBOARD_LARGE};
    padding: 0rem;
    margin: 0;
    background-color: ${Colours.OV_BASE};
    white-space: nowrap;

    &:hover {
      a {
        color: ${Colours.OV_BASE};
      }
    }

    a {
      border-radius: ${Variables.borderRadius.CLINIC_DASHBOARD_LARGE};
      padding: 0.25rem 1rem;
      text-decoration: none;
      text-transform: none;
      font-weight: bold;
      font-size: 0.75rem;
      color: ${Colours.OV_WHITE};
    }
  }
`;

const StatusLabel = styled.div`
  padding: 0.25rem;
  border-radius: ${Variables.borderRadius.CLINIC_DASHBOARD_LARGE};
  text-align: center;
  color: ${Colours.OV_WHITE};
  text-transform: uppercase;
  width: 5rem;
`;

const StyledText = styled.p`
  margin: 0;
  padding: 0;
`;
